import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BookingListLayer from "../../components/Booking/BookingListLayer";


const BookingList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Booking" />

        {/* BookingListLayer */}
        <BookingListLayer />

      </MasterLayout>

    </>
  );
};

export default BookingList; 
